import { TableL10n } from '@sym-ui/toolkit3/table';

export type ColumnConfig = {
  id: string;
  header: string;
  field: string;
  filtername: string;
  resizable: boolean;
  sortable: boolean;
  visible: boolean;
  width: string;
  is_default: boolean;
};

export const NAME_COLUMN_WIDTH = '200px';
export const CHANNEL_COLUMN_WIDTH = '160px';

export const NAME_COLUMN: ColumnConfig = {
  id: 'name',
  header: 'Name',
  field: 'name',
  filtername: 'Name',
  resizable: true,
  sortable: true,
  visible: true,
  width: NAME_COLUMN_WIDTH,
  is_default: true,
};

export const l10n: TableL10n = {
  applyLabel: 'Apply',
  cancelLabel: 'Cancel',
  columnSelector: {
    compileSelectionLabel: 'Compile Selection',
    filterPlaceholder: 'Search',
    resetLabel: 'Reset to Factory Default',
    selectAllLabel: 'Select All',
    undoResetLabel: 'Undo Reset',
  },
  columnSelectorModalHeader: 'Customize Columns',
  columnSelectorSelectedColumns: '{columnSelectionCount} of {totalColumns} Columns Selected',
  actionbarCaptionAllSelected: 'All {rowSelectionCount} selected',
  actionbarCaptionDefault: 'Notifications',
  actionbarCaptionIfSelection: '{rowSelectionCount} selected',
  actionbarCaptionPageSelected: 'All {recordsOnPage} on page selected',
  actionbarCaptionSelectAll: 'Select all {totalRecords}',
  actionbarCaptionUnselectButton: 'Clear',
  paginator: {
    currentPageReportPrefixTemplate: 'Page',
    currentPageReportTemplate: 'of {totalPages}',
    rowsPerPagePrefixTemplate: 'Items per page',
  },
};
